<form *ngIf="show.form" [ngClass]="{'invalid-submit': invalidSubmit}" [formGroup]="addEditForm" (ngSubmit)="saveOrUpdate(dialogBoxState)" RestrictFocus>

  <div class="ui-grid ui-grid-responsive ui-fluid" >

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.code.nullable}">{{ fields.code.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input type="text" formControlName="code" pInputText [maxlength]="fields.code.width" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.code"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.name.nullable}">{{ fields.name.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="name" pInputText [maxlength]="fields.name.width" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.name"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-10-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.description.nullable}">{{ fields.description.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <input formControlName="description" pInputText [maxlength]="fields.description.width" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.description"></app-validation-msg>
      </div>
    </div>

    <div class="ui-grid-row bottom-100-margin">
      <div class="ui-grid-col-4"><label [ngClass]="{'required': !fields.country_id.nullable}">{{ fields.country_id.keyName }}</label></div>
      <div class="ui-grid-col-8">
        <p-autoComplete
        [suggestions]="countries"
        [(ngModel)]="model.country"
        [ngModelOptions]="{standalone: true}"
        (completeMethod)="filterCountrySingle($event)"
        (onSelect)="onSelectCountry($event)"
        placeholder="{{ 'common.country' | translate }}"
        (onClear)="onClearCountry()"
        [minLength]="2"
        [required]="!fields.country_id.nullable"
        [dropdown]="true"
        field="name"
        >
      </p-autoComplete>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [(form)]="addEditForm" [validation]="fields.country_id"></app-validation-msg>
      </div>
    </div>

  </div>

  <p-footer>
    <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix" style="display: flex; justify-content: center; border: 0; margin-top: 15px;">
      <button class="k-generic-btn" type="submit" pButton icon="fa fa-check"
              label="{{dialogBoxState.id ? ('common.edit' | translate) :  ('common.add' | translate) }} {{ 'stateList.state' | translate }}"></button>
    </div>
  </p-footer>

</form>



// WEBPACK FOOTER //
// ./src/app/views/administration/state/stateForm.html